import { render, staticRenderFns } from "./BookingTag.vue?vue&type=template&id=43f47cd6"
import script from "./BookingTag.vue?vue&type=script&lang=js"
export * from "./BookingTag.vue?vue&type=script&lang=js"
import style0 from "./BookingTag.vue?vue&type=style&index=0&id=43f47cd6&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports